<ul class="w-100 list-group rounded-0">
    <li class="list-group-item d-block py-1">
        <div class="row w-100 d-flex align-items-center">
            <div class="col-9 text-truncate float-none form-check form-switch">
                <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="PinkwebDossier" (change)="toggleShowPlugins($event)" [checked]="pinkwebDossier?.enabled" [disabled]="!useClientOnline">
                <label class="col-10" for="PinkwebDossier" translate="Sources.PinkWebClientOnlineDossier"></label>
            </div>
            <div class="col-3 text-end">
                <div class="btn-group">
                    <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots bi-large"></i>
                    </button>
                    <ul class="dropdown-menu">
                    <li><a class="dropdown-item pt-1 pb-1" (click)="dialogClientOnline('PinkWebClientOnlineDossier')" translate="Button.Edit"></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </li>
    <li class="list-group-item d-block py-1">
        <div class="row w-100 d-flex align-items-center">
            <div class="col-9 text-truncate float-none form-check form-switch">
                <input class="float-none switch-form-default form-check-input items" type="checkbox" role="switch" id="PinkwebAccordering" (change)="toggleShowPlugins($event)" [checked]="pinkwebAccordering?.enabled" [disabled]="!useClientOnline">
                <label class="col-10" for="PinkwebAccordering" translate="Sources.PinkWebClientOnlineAccorderen"></label>
            </div>
            <div class="col-3 text-end">
                <div class="btn-group">
                    <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots bi-large"></i>
                    </button>
                    <ul class="dropdown-menu">
                    <li><a class="dropdown-item pt-1 pb-1" (click)="dialogClientOnline('PinkWebClientOnlineAccorderen')" translate="Button.Edit"></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </li>
</ul>